<form [formGroup]="basicForm">
  <div style="display:flex; justify-content:space-between; align-items:center">
    <div style="display:flex; justify-content:right; align-items:center; gap:20px">
      <h1 style="margin:0">SKU: {{ basicForm.getRawValue().InventoryTypeID }}</h1>
      <div style="width:800px"><rms-input [LargeInput]="true" formControlName="InventoryTypeName" [required]="true"></rms-input></div>
    </div>
    <div>
      <button class="btn-bg-blue" mat-stroked-button [matMenuTriggerFor]="ReportMenu">Reports</button>
    </div>
    <div>
      <h3 style="margin:0">Group: {{ basicForm.getRawValue().GroupName }}</h3>
    </div>
    <div style="display:flex; justify-content:right; align-items:center; gap:20px">
      <rms-checkbox name="Active" label="Active" formControlName="Active"></rms-checkbox>
    </div>
  </div>
  <mat-menu #ReportMenu>
    @for(report of CoffeeReports; track $index){
    <button mat-menu-item>{{report.label}}</button>
    }
  </mat-menu>
</form>
<hr class="rms-line" />
<form [formGroup]="form" class="form-flow" style="height:100%">
  <div class="fields" style="position:relative; display:flex; gap:20px">
    <div style="display:flex; justify-content:space-between; gap:20px; width:100%">
      <div style="display:flex; flex-direction:column; gap:20px; height:100%; width:50%">
        <div style="display:flex; justify-content:space-between; gap:20px">
          <fieldset class="rms-fieldset">
            <legend>Location Information</legend>
            <div class="fields">
              <rms-select name="Region"
                          label="Region"
                          formControlName="Region"
                          [options]="InventoryData.Regions"
                          labelKey="RegionName"
                          valueKey="RegionId"
                          [required]="true"></rms-select>
              <rms-select name="Country"
                          label="Country"
                          formControlName="Country"
                          [options]="FilteredCountries"
                          labelKey="CountryName"
                          valueKey="CountryID"
                          [required]="true"></rms-select>

              <rms-select name="SubRegion"
                          label="Sub-Region"
                          formControlName="SubRegion"
                          [options]="FilteredSubRegions"
                          labelKey="SubRegion"
                          valueKey="SubRegionID"></rms-select>

              <rms-input name="GrowingRegions"
                         label="Growing Regions"
                         formControlName="GrowingRegions"></rms-input>
            </div>
          </fieldset>

          <fieldset class="rms-fieldset">
            <legend>Harvest / Export Months</legend>
            <div class="fields">
              <rms-select name="HarvestStartMonth"
                          label="Harvest Start Month"
                          formControlName="HarvestStartMonth"
                          [options]="InventoryData.Months"
                          labelKey="label"
                          valueKey="value"></rms-select>

              <rms-select name="HarvestEndMonth"
                          label="Harvest End Month"
                          formControlName="HarvestEndMonth"
                          [options]="InventoryData.Months"
                          labelKey="label"
                          valueKey="value"></rms-select>

              <rms-select name="ExportStartMonth"
                          label="Export Start Month"
                          formControlName="ExportStartMonth"
                          [options]="InventoryData.Months"
                          labelKey="label"
                          valueKey="value"></rms-select>

              <rms-select name="ExportEndMonth"
                          label="Export End Month"
                          formControlName="ExportEndMonth"
                          [options]="InventoryData.Months"
                          labelKey="label"
                          valueKey="value"></rms-select>
            </div>
          </fieldset>

          <!-- Notes -->
          <fieldset class="rms-fieldset">
            <legend>Notes / Story</legend>
            <div class="fields">
              <rms-textarea [includePopout]="true" popoutTitle="Farm Story" name="FarmStory" label="Farm Story" formControlName="FarmStory"></rms-textarea>
              <rms-textarea [includePopout]="true" popoutTitle="Notes" name="Notes" label="Notes" formControlName="Notes"></rms-textarea>
            </div>
          </fieldset>
        </div>
        @if(Product.InventoryTypeID){
        <div>
          <fieldset class="rms-fieldset">
            <legend>Photos</legend>
            <div class="sku-photos-shell" style="width:45vw !important">
              <rms-slider [items]="InventoryImages" [pageSize]="4">
                <ng-template #static>
                  <div class="photo-tile add-tile"
                       appDragDrop
                       (fileDropped)="onFilesDropped($event)"
                       (click)="fileInput.click()">

                    <div class="add-icon">
                      <mat-icon>add</mat-icon>
                    </div>

                    <input #fileInput
                           type="file"
                           accept="image/*"
                           multiple
                           (change)="onFileSelected($event)"
                           hidden />
                  </div>
                </ng-template>
                <ng-template #item let-photo>

                  <div class="photo-tile image-tile">
                    <img [src]="photo.url" [alt]="photo.name" />

                    <div class="photo-actions">
                      <button class="icon-btn view" (click)="ViewImage(photo.url)">
                        <mat-icon>open_in_new</mat-icon>
                      </button>

                      <button class="icon-btn danger" (click)="DeleteImage(photo.name)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                </ng-template>

              </rms-slider>
            </div>

          </fieldset>
        </div>
        }
        @else{
          <fieldset class="rms-fieldset">
            <legend>Autofill</legend>
            <div style="display:flex; flex-direction:column; align-items:center; width:100%">
              <h3>Select product to autofill details.</h3>
              <div style="width:100%">
                <rms-search-select label="Product" [options]="InventoryData.Products" labelKey="InventoryTypeName" valueKey="InventoryTypeID" name="AutofillProduct" (selectionChange)="UpdateAutofill($event)"></rms-search-select>
              </div>
            </div>
          </fieldset>
        }
      </div>

      <!-- DNA Editor -->
      <fieldset class="rms-fieldset form-flow" style="width: 43vw; height: 58vh">
        <legend>Product & Lot Information</legend>
        <div class="fields" [formGroup]="form.controls.dna">

          @for (gene of SortedGenes; track gene.GeneKey) {
          <ng-container [ngSwitch]="gene.MultiSelect">
            <!-- ✅ MULTI SELECT GENES -->
            <rms-multi-select *ngSwitchCase="true"
                              [label]="gene.GeneName"
                              [options]="traitsByGene(gene)"
                              [formControlName]="gene.GeneKey"
                              maxHeight="250px"
                        [exclusiveValues]="[108]"
                              [requiredOptions]="gene.GeneKey == 2 ? 1 : 0">
            </rms-multi-select>

            <!-- ✅ SINGLE SELECT GENES -->
            <rms-select *ngSwitchDefault
                        [label]="gene.GeneName"
                        [options]="TraitsByGene.get(gene.GeneKey)!"
                        labelKey="TraitName"
                        valueKey="TraitKey"
                        [formControlName]="gene.GeneKey"
                        [required]="gene.GeneKey == 1 || gene.GeneKey == 7">
            </rms-select>

          </ng-container>

          }

        </div>
      </fieldset>
    </div>
  </div>
  <div style="width:100%; display:flex; justify-content: right; margin-top:30px">
    <button mat-surface-button
            (click)="submit()"
            class="btn-bg-green"
            [disabled]="(!form.dirty && !basicForm.dirty) || form.invalid || basicForm.invalid">
      Submit
    </button>
    @if(!Product.InventoryTypeID){<button mat-surface-button class="btn-bg-red" (click)="CancelSku()">Cancel</button>}
  </div>
</form>
